<template>
  <a-upload
    v-model:file-list="image_files"
    name="file"
    :multiple="false"
    action=""
    :headers="headers_image"
    @change="handleChangeImage"
    :before-upload="beforeImageUpload"
  >
    <a-space>
      <a-button>
        <upload-outlined></upload-outlined>
        Click to Upload
      </a-button>
      <a-spin
        v-if="is_image_loading"
      />
    </a-space>
  </a-upload>
  <img
    v-if="imageInfo && imageInfo.contentType"
    class="admin-asset-image"
    :src="'data:' + imageInfo.contentType + ';base64,' + imageInfo.base64ImageData"
  />
</template>

<script setup>

import {defineEmits, defineProps, ref, watch} from "vue";
import {UploadOutlined} from "@ant-design/icons-vue";
import {message} from "ant-design-vue";

const props = defineProps({
  objectProperties: Object
});

const emit = defineEmits(['update:image']);

const imageInfo = ref({
  contentType: "",
  base64ImageData: ""
});

watch(() => props.objectProperties, (newValue) => {
  let obj_attributes = newValue.attributes;

  for (let idx in obj_attributes) {
    let attr = obj_attributes[idx];
    if (attr["name"] === 'contentType') {
      imageInfo.value.contentType = attr["value"];
    } else if (attr["name"] === 'base64ImageData') {
      //var blob = new Blob( [ attr["value"] ], /*{ type: "image/jpeg" }*/ );
      imageInfo.value.base64ImageData = attr["value"];
      //imageInfo.value.imageData = URL.createObjectURL( blob );
    }
  }
}, {"immediate": true});

// =================================================================================================================
//  Upload image functionality
// =================================================================================================================
// eslint-disable-next-line
const image_files = ref([]);
const is_image_loading = ref(false);

// eslint-disable-next-line
const handleChangeImage = (info) => {
  if (info.file.status !== 'uploading') {
    console.log(info.file, info.fileList);
  }

  if (info.file.status === 'done') {
    message.success(`${info.file.name} file uploaded successfully`);
  } else if (info.file.status === 'error') {
    message.error(`${info.file.name} file upload failed.`);
  }
};

// eslint-disable-next-line
const headers_image = ref({
    authorization: 'authorization-text',
});

// eslint-disable-next-line
const beforeImageUpload = file => {
  return new Promise(() => {
    is_image_loading.value = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      let res = reader.result;
      // eslint-disable-next-line
      let [content_type, data] = res.split(',');

      imageInfo.value.contentType = content_type.split(';')[0];
      imageInfo.value.base64ImageData = data;
      emit("update:image", imageInfo.value);

      is_image_loading.value = false;
    };

    return false;
  });
}

</script>